import { render, staticRenderFns } from "./SuperSlide.vue?vue&type=template&id=3fe98b9e&scoped=true"
import script from "./SuperSlide.vue?vue&type=script&lang=js"
export * from "./SuperSlide.vue?vue&type=script&lang=js"
import style0 from "./SuperSlide.vue?vue&type=style&index=0&id=3fe98b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe98b9e",
  null
  
)

export default component.exports